import ObjectNameReference from 'automation-ui-enrollment/components/filters/enrollment/generic-enrollment-table/ObjectNameReference';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import BranchOverrideView from 'automation-ui-canvas/containers/flow-views/test-flow/simulation/BranchOverrideView';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RandomBranchPreview = ({
  flow,
  recordId,
  logEvent,
  branchOverrideValue,
  setBranchOverrideValue
}) => {
  var _logEvent$contextMap;
  const connectionIndex = (_logEvent$contextMap = logEvent.contextMap) === null || _logEvent$contextMap === void 0 ? void 0 : _logEvent$contextMap.ACCEPTED_CONNECTION_INDEX;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "automation.testV2.simulatePanel.randomBranch",
      options: {
        connectionIndex: connectionIndex + 1,
        recordTitle: /*#__PURE__*/_jsx(ObjectNameReference, {
          objectTypeId: flow.objectTypeId,
          id: recordId
        })
      }
    }), /*#__PURE__*/_jsx(BranchOverrideView, {
      marginBlockStart: "200",
      event: logEvent,
      branchOverrideValue: branchOverrideValue,
      setBranchOverrideValue: setBranchOverrideValue,
      flow: flow
    })]
  });
};
export default RandomBranchPreview;